/**
 * 絞り込み検索 - 価格設定プルダウン
 */
import CustomPulldownBase from "./script-pulldown-base.js";

export default class PulldownPrice extends CustomPulldownBase {

  constructor() {
    super();
  }

  /**
   * プルダウン選択時の個別実行処理
   */
  selectItem(e) {
    
  }
}
